import React from 'react';
import { motion } from 'framer-motion';
import { FracturedHalo } from './FracturedHalo';
import { Globe } from 'lucide-react';
export const Footer: React.FC = () => {
  return <footer className="bg-black py-16 relative overflow-hidden" data-id="element-56">
      <div className="thin-divider mb-16" data-id="element-57" />
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-58">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10" data-id="element-59">
          <div className="md:col-span-2" data-id="element-60">
            <motion.div className="flex items-center mb-6" initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.6
          }} viewport={{
            once: true
          }} data-id="element-61">
              <div className="mr-4 relative w-10 h-10" data-id="element-62">
                <FracturedHalo size={40} segments={6} opacity={0.8} animate={false} data-id="element-63" />
              </div>
              <h3 className="text-2xl font-heading font-light tracking-wider text-neon-blue" data-id="element-64">
                DEPLOID
              </h3>
            </motion.div>
            <motion.p className="text-neon-blue/70 max-w-md mb-8" initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} viewport={{
            once: true
          }} data-id="element-65">
              Deploy the future with confidence. DEPLOID transforms AI from
              concept to reality with precision, expertise, and vision.
            </motion.p>
            <motion.div className="flex space-x-4" initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.4
          }} viewport={{
            once: true
          }} data-id="element-66">
              {['LinkedIn', 'Twitter', 'GitHub'].map((platform, index) => <a key={index} href="#" className="text-neon-blue/70 hover:text-neon-blue transition-colors text-sm" data-id="element-67">
                  {platform}
                </a>)}
            </motion.div>
          </div>
          <div data-id="element-68">
            <motion.h4 className="text-neon-blue font-heading font-light text-lg mb-4" initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} transition={{
            duration: 0.6
          }} viewport={{
            once: true
          }} data-id="element-69">
              Services
            </motion.h4>
            <motion.ul className="space-y-3" initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} viewport={{
            once: true
          }} data-id="element-70">
              {['AI Strategy', 'Industry Tailored Agents', 'Integration', 'Security & Compliance'].map((service, index) => <li key={index} data-id="element-71">
                  <a href="#" className="text-neon-blue/70 hover:text-neon-blue transition-colors text-sm" data-id="element-72">
                    {service}
                  </a>
                </li>)}
            </motion.ul>
          </div>
          <div data-id="element-73">
            <motion.h4 className="text-neon-blue font-heading font-light text-lg mb-4" initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} transition={{
            duration: 0.6
          }} viewport={{
            once: true
          }} data-id="element-74">
              Contact
            </motion.h4>
            <motion.ul className="space-y-3" initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} viewport={{
            once: true
          }} data-id="element-75">
              <li data-id="element-76">
                <a href="mailto:sales@deploid.com" className="text-neon-blue/70 hover:text-neon-blue transition-colors text-sm" data-id="element-77">
                  sales@deploid.com
                </a>
              </li>
              <li className="flex items-start gap-2" data-id="element-78">
                <Globe className="w-4 h-4 text-neon-blue/70 mt-0.5 flex-shrink-0" data-id="element-79" />
                <span className="text-neon-blue/70 text-sm" data-id="element-80">Singapore</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-81">
                <Globe className="w-4 h-4 text-neon-blue/70 mt-0.5 flex-shrink-0" data-id="element-82" />
                <span className="text-neon-blue/70 text-sm" data-id="element-83">Australia</span>
              </li>
            </motion.ul>
          </div>
        </div>
        <div className="thin-divider my-10" data-id="element-84" />
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-85">
          <motion.p className="text-neon-blue/50 text-sm mb-4 md:mb-0" initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} transition={{
          duration: 0.6
        }} viewport={{
          once: true
        }} data-id="element-86">
            © 2026 DEPLOID. All rights reserved.
          </motion.p>
          <motion.div className="flex space-x-6" initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} viewport={{
          once: true
        }} data-id="element-87">
            {['Privacy Policy', 'Terms of Service', 'Cookie Policy'].map((link, index) => <a key={index} href="#" className="text-neon-blue/50 hover:text-neon-blue/80 transition-colors text-sm" data-id="element-88">
                  {link}
                </a>)}
          </motion.div>
        </div>
      </div>
      <div className="absolute bottom-6 right-6 opacity-40 animate-spin-slow" data-id="element-89">
        <FracturedHalo size={60} segments={5} opacity={0.6} animate={false} data-id="element-90" />
      </div>
    </footer>;
};